import { type Context, createContext, type Provider, type SyntheticEvent, useContext } from 'react'

export type NativeModalContextProps = {
  onClose?: (event: SyntheticEvent, reason?: 'backdropClick' | 'escapeKeyDown') => void
}

export const NativeModalContext: Context<NativeModalContextProps | null> =
  createContext<NativeModalContextProps | null>(null)

export const useNativeModalContext = (): NativeModalContextProps => {
  const context = useContext(NativeModalContext)

  if (!context) {
    throw Error('NativeModal components must be used within a NativeModalContext')
  }

  return context
}

export const NativeModalProvider: Provider<NativeModalContextProps | null> = NativeModalContext.Provider
